// import { useGet, usePost } from './index'
// import { useRouter } from 'vue-router'
// import type { AxiosResponse } from 'axios'
// import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '~/shared/constants'

// interface LoginCredentials {
//     email: string,
//     password: string
// }

// export function useLogin(data: LoginCredentials) : Promise<any> {
//     return new Promise((resolve, reject) => {
//         usePost('/login', {}).then((res : AxiosResponse) => {
//             localStorage.setItem(ACCESS_TOKEN_KEY, res.data.access_token)
//             localStorage.setItem(REFRESH_TOKEN_KEY, res.data.refresh_token)
//             resolve(res.data)
//         }).catch(err => reject(err))
//     })
// }

// export function useLogout() : Promise<any> {
//     return new Promise((resolve, reject) => {
//         const router = useRouter()
//         localStorage.removeItem(ACCESS_TOKEN_KEY)
//         localStorage.removeItem(REFRESH_TOKEN_KEY)
//         router.replace('/login')
//         usePost('/logout', {}).then(() => {
//             resolve({ success: true })
//         }).catch(err => reject(err))
//     })
// }

// export function isUserLoggedIn() {
//     return localStorage.getItem(ACCESS_TOKEN_KEY)
// }

// export function fetchProfileInfo() : Promise<any> {
//     return new Promise((resolve, reject) => {
//         useGet('/me').then(res => {
//             resolve(res.data)
//         }).catch(err => reject(err))
//     })
// }

// export function useRegister(data: any) : Promise<any> {
//     return new Promise((resolve, reject) => {
//         usePost('/register', data).then(res => {
//             resolve(res.data)
//         }).catch(err => reject(err))
//     })
// }

import { usePost, useGet } from "./index";
import router from "~/router";
import type { AxiosResponse } from "axios";
import { ACCESS_TOKEN_KEY } from "~/shared/constants";

interface LoginCredentials {
  email: string;
  password: string;
}

// Login funksiyasi
export function useLogin(data: LoginCredentials): Promise<any> {
  return new Promise((resolve, reject) => {
    usePost("/login", data)
      .then((res: AxiosResponse) => {
        localStorage.setItem(ACCESS_TOKEN_KEY, res.data?.authorization.token);
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
}

// Logout funksiyasi
export function useLogout(): void {
  let currentPath = window.location.pathname;
  currentPath = currentPath=='/auth/login' ? '/' : currentPath;
  router.push("/auth/login?redirectFrom=" + currentPath);
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem("userAbilities");
}

// Foydalanuvchi tizimga kirganligini tekshirish
export function isUserLoggedIn(): boolean {
  return !!localStorage.getItem(ACCESS_TOKEN_KEY);
}
